import { render, staticRenderFns } from "./MessageCardIcon.vue?vue&type=template&id=d3689f8a&"
import script from "./MessageCardIcon.vue?vue&type=script&lang=js&"
export * from "./MessageCardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports